/**
 * MainBackground component
 */
import AccentMask from '@components/atoms/mask/accentMask';
import BottomBackgroundMask from '@components/atoms/mask/bottomBackgroundMask';
import ContentMask from '@components/atoms/mask/sliderMask';
import DescriptionBackground from './descriptionBackground';
import MainBackgroundContainer from '@components/atoms/container/mainBackgroundContainer';
import { useAppSelector } from '@shared/store/hooks';
import { focusSelector } from '@shared/store/slices/focus.slice';
import Focus from '@shared/types/enums/focus';
import { routerSelector } from '@shared/store/slices/router.slice';
import Pages from '@pages';

/**
 * This component displays several masks that cover the background of the app.
 */
export default function MainBackground() {
  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------
  const { focus } = useAppSelector(focusSelector);
  const { route } = useAppSelector(routerSelector);
  const miniDetailFocused =
    focus === Focus.RAILS_LIST ||
    focus === Focus.CHANNELS_RAIL ||
    ((focus === Focus.FILTER_RAIL || focus === Focus.MENU) &&
      route.Page === Pages.CHANNELS_GRID) ||
    focus === Focus.FLOATING_MENU ||
    focus === Focus.MODAL_BUTTONS;
  return (
    <MainBackgroundContainer>
      <DescriptionBackground />
      <ContentMask display={true} miniDetailFocused={miniDetailFocused} />
      {/* <TopBackgroundMask miniDetailFocused={miniDetailFocused} /> */}
      <BottomBackgroundMask miniDetailFocused={miniDetailFocused} />
      <AccentMask />
    </MainBackgroundContainer>
  );
}
